var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    height: "auto",
    viewBox: "0 0 824.577 725.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4093",
    "data-name": "Trac\\xE9 4093",
    d: "M0,0H157.362V163.657H0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4096",
    "data-name": "Trac\\xE9 4096",
    d: "M0,0H151.069V132.185H0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21914",
    "data-name": "Groupe 21914",
    transform: "translate(-472 -232.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21913",
    "data-name": "Groupe 21913",
    transform: "translate(-36.801 -145.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u601D\\u8003\\u53D1\\u6563",
    transform: "translate(445.801 344.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4068",
    "data-name": "Trac\\xE9 4068",
    d: "M110.061,615.812S315.733,507.468,227.283,419.584c-55.226-54.9-101.3-136.278-105.976-211.931-4.349-70.718,59.725-127.129,134.9-126.87,57.6.19,102.651,28.108,139.308,67.062,30.612,32.508,83.947,138.27,144.5,122.754,13.043-3.346,22.333-13.6,32.658-21.692,47.4-37.112,68.681,25.565,69.24,58.987.614,38.244-7.888,76.908-17.142,114-5.486,22.02-48.147,193.911-63.547,193.911l-451.164.009Z",
    transform: "translate(94.564 94.003)",
    fill: "#ecf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4069",
    "data-name": "Trac\\xE9 4069",
    d: "M148.117,113.1a4.229,4.229,0,1,1-1.24-2.988,4.216,4.216,0,0,1,1.24,2.988Zm26.669,0a4.236,4.236,0,1,1-4.228-4.228,4.243,4.243,0,0,1,4.228,4.228Zm26.666,0a4.228,4.228,0,1,1-4.228-4.228A4.216,4.216,0,0,1,201.453,113.1Zm26.669,0a4.228,4.228,0,1,1-4.228-4.228,4.237,4.237,0,0,1,4.228,4.228Zm26.678,0a4.237,4.237,0,1,1-2.245-3.728A4.258,4.258,0,0,1,254.8,113.1Zm26.666,0a4.234,4.234,0,1,1-4.241-4.112,4.234,4.234,0,0,1,4.241,4.112Zm-133.35,25.98a4.228,4.228,0,1,1-3-4.046,4.216,4.216,0,0,1,3,4.046Zm26.669,0a4.228,4.228,0,1,1-4.228-4.225,4.243,4.243,0,0,1,4.228,4.225Zm26.666,0a4.228,4.228,0,1,1-3-4.046,4.216,4.216,0,0,1,3,4.046Zm26.669,0a4.228,4.228,0,1,1-3-4.046,4.237,4.237,0,0,1,3,4.046Zm26.678,0a4.216,4.216,0,1,0,0,.024m26.666-.024a4.234,4.234,0,1,1-4.241-4.112A4.234,4.234,0,0,1,281.467,139.075Zm-133.35,25.983a4.233,4.233,0,1,1-4.233-4.233,4.233,4.233,0,0,1,4.233,4.233Zm26.669,0a4.241,4.241,0,1,1-1.24-2.991A4.231,4.231,0,0,1,174.787,165.059Zm26.666,0a4.231,4.231,0,1,1-3.405-4.135A4.231,4.231,0,0,1,201.453,165.059Zm26.669,0a4.228,4.228,0,1,1-4.23-4.227A4.228,4.228,0,0,1,228.122,165.059Zm26.678,0a4.236,4.236,0,1,1-4.237-4.228,4.255,4.255,0,0,1,4.237,4.228Zm26.666,0a4.132,4.132,0,1,1-1.243-2.991,4.231,4.231,0,0,1,1.243,2.991Zm-133.35,25.986a4.231,4.231,0,1,1-2.237-3.724,4.216,4.216,0,0,1,2.237,3.724Zm26.669,0a4.228,4.228,0,1,1-2.358-3.792A4.243,4.243,0,0,1,174.787,191.045Zm26.666,0a4.228,4.228,0,1,1-4.228-4.228,4.216,4.216,0,0,1,4.228,4.228Zm26.669,0a4.228,4.228,0,1,1-4.228-4.228,4.237,4.237,0,0,1,4.228,4.228Zm26.678,0a4.234,4.234,0,1,1-4.238-4.067A4.234,4.234,0,0,1,254.8,191.045Zm26.666,0a4.234,4.234,0,1,1-4.241-4.112A4.234,4.234,0,0,1,281.467,191.045Zm-133.35,25.983a4.23,4.23,0,1,1-4.222-4.237A4.23,4.23,0,0,1,148.117,217.028Zm26.669,0a4.216,4.216,0,1,1-2.609-3.915,4.249,4.249,0,0,1,2.609,3.915Zm26.666,0a4.239,4.239,0,1,1-1.234-3,4.213,4.213,0,0,1,1.234,3Zm26.669,0a4.239,4.239,0,1,1-1.234-3,4.213,4.213,0,0,1,1.234,3Zm26.678,0a4.234,4.234,0,1,1-1.24-3,4.22,4.22,0,0,1,1.24,3Zm26.666,0a4.235,4.235,0,1,1-1.24-3,4.216,4.216,0,0,1,1.24,3Zm-133.35,25.98a4.231,4.231,0,1,1-2.233-3.731,4.21,4.21,0,0,1,2.233,3.731Zm26.669,0a4.235,4.235,0,1,1-.322-1.622,4.258,4.258,0,0,1,.322,1.622Zm26.666,0a4.227,4.227,0,1,1-1.234-2.994A4.21,4.21,0,0,1,201.453,243.008Zm26.669,0a4.227,4.227,0,1,1-1.234-2.994A4.21,4.21,0,0,1,228.122,243.008Zm26.678,0a4.237,4.237,0,1,1-4.233-4.242A4.237,4.237,0,0,1,254.8,243.008Zm26.666,0a4.234,4.234,0,1,1-4.236-4.233,4.234,4.234,0,0,1,4.236,4.233Z",
    transform: "translate(154.025 150.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4070",
    "data-name": "Trac\\xE9 4070",
    d: "M200.661,34c9.284,10.391,20.046,20.073,32.462,26.549,11.382,5.913,24.59,9.01,37.223,6.651,5.5-1.011,11.782-4.306,11.827-9.9.072-5.345-5.588-8.812-10.674-10.473A64.13,64.13,0,0,0,242.672,44.3c-9.609,1.375-20.133,6.29-22.453,15.721-1.8,7.313,2.052,14.909,7.108,20.482A48.788,48.788,0,0,0,257.972,96.03c26.486,2.787,21.117-26.049-5.706-22.528-4.975.656-10.066,1.475-14.361,4.1s-7.644,7.346-7.156,12.342a16.579,16.579,0,0,0,3.262,7.629,44.078,44.078,0,0,0,21.65,16.467c4.773,1.649,11.655,1.481,13.046-3.416.8-2.808-.933-5.838-3.319-7.514-6.238-4.394-16.467.169-17.385,7.737-1.249,10.349,10.984,13.112,18.761,13.121",
    transform: "translate(276.616 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4071",
    "data-name": "Trac\\xE9 4071",
    d: "M301.22,158.173a6.828,6.828,0,1,1-2-4.83,6.847,6.847,0,0,1,2,4.83Z",
    transform: "translate(451.24 235.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4072",
    "data-name": "Trac\\xE9 4072",
    d: "M189.446,236.283,217.283,216.5l12.1,23.476-30.488,17.28-9.447-20.97Z",
    transform: "translate(254.081 366.708)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4073",
    "data-name": "Trac\\xE9 4073",
    d: "M201.776,223.071,183.31,233.953l7.894,9.778,3.262-.96-1.613,4.671L214.4,274.11l5.291-4.273-6.91-18.974,2.763-3.244Z",
    transform: "translate(241.751 379.92)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4074",
    "data-name": "Trac\\xE9 4074",
    d: "M191.03,232.6l8.056-.442-4.559,8.73,7.915,1.676-3.629,6.127,4.406.253",
    transform: "translate(257.264 398.171)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4075",
    "data-name": "Trac\\xE9 4075",
    d: "M218.04,274.463l-.238-34.157,26.167,3.563-3.334,34.888-22.595-4.294Z",
    transform: "translate(311.06 414.552)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4076",
    "data-name": "Trac\\xE9 4076",
    d: "M219.005,251.656l-1.685,21.367,12.537-.855,1.086-3.223,2.9,4,34.208-2.341-.466-6.786-19.507-5.224L247,254.464l-28-2.808Z",
    transform: "translate(310.091 437.359)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4077",
    "data-name": "Trac\\xE9 4077",
    d: "M226.349,260.229l4.249-6.852,4.538,8.745,5.913-5.522,2.943,6.491,2.733-3.467",
    transform: "translate(328.234 440.817)",
    fill: "#060000",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4078",
    "data-name": "Trac\\xE9 4078",
    d: "M156.718,167.9H467.285",
    transform: "translate(188.317 269.059)",
    fill: "none",
    stroke: "#010541",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4079",
    "data-name": "Trac\\xE9 4079",
    d: "M201.358,154.429s19.4,122.7,25.685,135.447c0,0-.488,137.361,13.01,162.7l48.391-6.422S293.9,250.191,280,207.091c0,0,18.9,60.08,21.686,61.876l55.569-29.288s-20.28-79.692-40.356-94.23l-115.543,8.98Z",
    transform: "translate(278.017 223.946)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4080",
    "data-name": "Trac\\xE9 4080",
    d: "M317.41,202.439s-114.279,84.733-123.533,91.387l27.407,42.923c42.685-21.755,86.036-45.31,124.021-74.654,30.3-23.38,40.537-48.74,27.674-85.329Z",
    transform: "translate(262.985 286.874)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4081",
    "data-name": "Trac\\xE9 4081",
    d: "M227.442,98.114c-8.222,4.355-14.623,1.481-17.328-4.309-2.489-5.387.12-13.422,7.475-13.362a18.661,18.661,0,0,1,8.493,2.377,25.916,25.916,0,0,1,3.178,4.785c1.773,3.494,2.8,8.065-1.818,10.509Z",
    transform: "translate(293.77 93.323)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4082",
    "data-name": "Trac\\xE9 4082",
    d: "M226.473,121.485c16.209,6.41,26.919-3.238,28.493-17.364.7-6.26.888-13.1-1.863-18.9-2.5-5.315-6.651-9.609-12.3-11.3-11.782-3.554-24.548,4.228-28.493,17.364v.123a24.7,24.7,0,0,0,14.2,30.076",
    transform: "translate(297.836 78.49)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4083",
    "data-name": "Trac\\xE9 4083",
    d: "M221.09,87.417a8.748,8.748,0,0,0-9.609-5.1c-1.08.208-.918,1.9.163,1.706a7.012,7.012,0,0,1,7.806,3.984c.451,1.005,2.055.412,1.61-.593",
    transform: "translate(296.884 96.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4084",
    "data-name": "Trac\\xE9 4084",
    d: "M218.879,86.013l-4.5,19.633,14.367,3.292,4.5-19.633Z",
    transform: "translate(304.19 104.515)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4085",
    "data-name": "Trac\\xE9 4085",
    d: "M223.84,83.725a1.6,1.6,0,1,1,.045-2.152,1.529,1.529,0,0,1-.045,2.152Zm6.437,9.895a34.364,34.364,0,0,0,1.339-9.97c0-.984-1.523-1.168-1.478-.184a33.255,33.255,0,0,1-1.288,9.609c-.265.924,1.183,1.475,1.481.56",
    transform: "translate(317.622 94.482)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4086",
    "data-name": "Trac\\xE9 4086",
    d: "M253.243,99.825c-5.549-.74-24.184-10.674-27.7.533-.894,2.853-.828,6.533-3.849,6.422a3.512,3.512,0,0,1-3.039-3.361,20.021,20.021,0,0,0-7.442-.65c0-19.537,9.651-24.533,14.695-23.01,0,0,16.585-18.673,23.016-5.709,0,0,20.635-9.179,23.741,10.5s-19.426,15.273-19.426,15.273Z",
    transform: "translate(297.828 71.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4087",
    "data-name": "Trac\\xE9 4087",
    d: "M285.5,116.256c-1.366,9.985-21.012,15.523-43.9,12.417s-40.323-13.753-38.954-23.741,21.021-15.523,43.9-12.426S286.865,106.27,285.5,116.256Z",
    transform: "translate(280.454 115.835)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4088",
    "data-name": "Trac\\xE9 4088",
    d: "M214.675,88.66s14.259,6.32,20.467,2.567",
    transform: "translate(304.776 109.834)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4089",
    "data-name": "Trac\\xE9 4089",
    d: "M260.779,100.563,207.022,93.4l.021.181,53.8,7.4Z",
    transform: "translate(289.398 119.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4090",
    "data-name": "Trac\\xE9 4090",
    d: "M263.387,132.955l26.161-18.481L301.5,131.6l-20.32,17.882",
    transform: "translate(402.658 161.705)",
    fill: "#f2d3dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21903",
    "data-name": "Groupe 21903",
    transform: "translate(63 546.158)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4091",
    "data-name": "Trac\\xE9 4091",
    d: "M204.11,319.118c-21.036,12.721,16.729,48.141,16.729,48.141l-33.462,22.793c-6.8-3.211-11.451-6.888-14.608-10.605l-13.615,15.33c-11.848-.527-24.34-4.451-30.067-15.67-1.8-3.542-1.95-8.158-2.1-12.706-.2-5.956-.391-11.794-4.273-14.948-3.151-2.555-7.725-3.635-11.619-4.316-2.025-.361-13.7-2.371-15.234-.361,7.855-10.268-6.055-3.75-6.055-3.75-4.641-1.568-6.621-10.581-8.134-17.482a49.25,49.25,0,0,0-1.733-6.642c-1.309-3.238-13.35-25.33-17.178-23.934,16.558-6.04,34.364-1.878,48.481,8.071,6.037,4.234,9.949,10.06,13.3,16.513.349.665.984,2.245,1.77,4.2,2.131,5.309,5.384,13.4,7.036,13.612,2.083.265,20.073,10.337,34.226,18.406.975-5.017-4.647-12.351-4.647-12.351-17.873-16.188-2.793-31.623-2.793-31.623,6.491-6.636,2.7-18.412-2.128-24.62-1.818-2.338-4.737-4.1-7.689-5.874-4.884-2.946-9.859-5.941-10.051-11.7-.105-3.19,1.607-5.941,3.34-8.715a33.08,33.08,0,0,0,2.507-4.523c3.076-7.283-.466-15.161-5.913-20.232-1.126-1.044-2.347-2.031-3.575-3.021-3.482-2.811-6.973-5.628-8.252-9.8-1.73-5.64,1.613-11.923,6.533-15.122s11.087-3.867,17-3.623c10.524.43,21.225,3.666,29.092,10.68,11.255,10.03,15.1,26.233,14.442,41.3v.024c-.488,11.252-.837,19.293,7.466,27.566.96.957,1.971,1.9,2.988,2.838,5.167,4.791,10.419,9.654,9.4,17.518C214.5,310.662,209.241,316.013,204.11,319.118Z",
    transform: "translate(-63.474 -203.515)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21902",
    "data-name": "Groupe 21902",
    transform: "translate(-0.695 -5.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4092",
    "data-name": "Trac\\xE9 4092",
    d: "M132.334,202.376c2.308,8.938,8.294,14.614,15.522,19.817,4.562,3.274,10.208,6.157,13.563,10.807,4.851,6.72,1.562,12.919,2.269,20.569.4,4.264,1.929,8.574,5.035,11.517,12.564,11.884,19.624,21.436,17.74,39.685-2.669,25.736-4.237,55.183,20.163,72.015M62.769,299.258a62.427,62.427,0,0,1,39.995,27.407c4.036,6.386,5.3,14.31,11.613,18.935,6.437,4.725,14.945,5.619,22.218,8.487,13.371,5.269,22.468,18.706,27.061,31.9",
    transform: "translate(-62.769 -202.376)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.184
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21905",
    "data-name": "Groupe 21905",
    transform: "translate(733.363 577.631)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4094",
    "data-name": "Trac\\xE9 4094",
    d: "M299.473,310.126c17.452,10.524-13.873,39.914-13.873,39.914l27.762,18.92c22.706-10.741,16.594-27.792,16.594-27.792-1.478-4.132,3.7-10.894,3.7-10.894,14.836-13.422,2.323-26.233,2.323-26.233-5.384-5.507-2.257-15.264,1.767-20.422,1.514-1.941,3.939-3.4,6.389-4.878,4.06-2.444,8.183-4.926,8.342-9.705.09-2.669-1.351-4.978-2.8-7.3a27.477,27.477,0,0,1-2.052-3.684c-2.549-6.037.385-12.579,4.908-16.786.939-.873,1.959-1.7,2.982-2.522,2.877-2.32,5.76-4.649,6.819-8.113,1.433-4.695-1.315-9.913-5.426-12.564s-9.239-3.2-14.123-3c-8.739.364-17.608,3.055-24.141,8.872-9.335,8.321-12.528,21.761-11.98,34.259v0c.412,9.362.707,16.037-6.187,22.911-.8.8-1.643,1.58-2.489,2.362-4.285,3.972-8.634,8-7.794,14.526.665,5.116,5.035,9.558,9.284,12.131Zm75.106,3.325c-3.524,1.493-45.5,44.473-45.5,44.473l35.207,22.76c12.179-3.978,24.042-11.7,26.763-25.005.864-4.222-.319-9.082-1.481-13.87-1.517-6.244-3-12.363.12-16.762,2.543-3.569,6.985-6.016,10.846-7.855l.018-.009c2.061-.981,13.527-6.419,15.739-4.767-11.153-8.42,5.212-5.655,5.212-5.655,4.379-2.979,3.834-12.937,3.416-20.563a53.3,53.3,0,0,1-.12-7.4c.421-3.78,6.579-30.232,10.96-29.892-18.971-1.493-36.3,7.99-48.123,22.426-5.041,6.148-7.421,13.341-9.049,21.027-.169.8-.376,2.648-.629,4.935-.686,6.145-1.721,15.459-3.377,16.154Z",
    transform: "translate(-286.069 -213.879)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21904",
    "data-name": "Groupe 21904",
    transform: "translate(13.714 -36.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4095",
    "data-name": "Trac\\xE9 4095",
    d: "M364.621,202.376c-2.308,8.938-8.294,14.614-15.523,19.817-4.568,3.274-10.208,6.157-13.572,10.807-4.839,6.72-1.553,12.919-2.26,20.569-.4,4.264-1.929,8.574-5.041,11.517-12.567,11.884-19.618,21.436-17.74,39.685,2.669,25.736,4.228,55.183-20.172,72.015M426.287,274.325a67.423,67.423,0,0,0-33.705,40.1c-2.356,7.815-1.381,16.425-6.651,23.064-5.339,6.777-13.934,10.169-20.7,15.261-12.39,9.35-17.984,25.968-18.944,41.039",
    transform: "translate(-290.313 -202.376)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.184
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4097",
    "data-name": "Trac\\xE9 4097",
    d: "M77.641,258.568H858.157",
    transform: "translate(29.42 451.248)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4098",
    "data-name": "Trac\\xE9 4098",
    d: "M192.237,158.454s-4.737,8.833-6.687,11.716c-4.665,6.895-16.44,9.934-16.44,9.934a3.545,3.545,0,0,0-1.8,3.28c0,1.929,1.228,3.488,2.736,3.488h24.391c5.507,0,10.813-2.66,14.848-7.442l10.771-12.751,8.447-8.225H192.237Z",
    transform: "translate(209.585 250.078)",
    fill: "#f2d3dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4099",
    "data-name": "Trac\\xE9 4099",
    d: "M188.18,158.577l-5.417,21.436c-.813,3.214,1.056,6.512,3.7,6.512a4.026,4.026,0,0,0,3.614-3.148l7.71-24.924Z",
    transform: "translate(240.267 250.078)",
    fill: "#f2d3dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4101",
    "data-name": "Trac\\xE9 4101",
    d: "M252.937,98.179,207.67,91.95,227.7,246.621l56.45-6.392L252.937,98.179Z",
    transform: "translate(290.7 116.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4102",
    "data-name": "Trac\\xE9 4102",
    d: "M206.815,151.561l114.917-17.217s30.2,43.329-114.917,41.039",
    transform: "translate(288.982 201.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4103",
    "data-name": "Trac\\xE9 4103",
    d: "M213.191,129.918,171.968,293.4h50.507l20.238-80.273,9.5,76.872h59.132L282.75,93.8,268.618,91.78c-22.631-3.112-47.356,8.661-55.427,38.138Z",
    transform: "translate(218.961 115.129)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4104",
    "data-name": "Trac\\xE9 4104",
    d: "M212.723,89.66l-3.945,7.421,19.01,16.167,6.9-11.836L212.723,89.66Zm21.969,11.755,8.417,10.783,7.71-9.284L243.4,94.192l-8.706,7.223Z",
    transform: "translate(292.927 111.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4105",
    "data-name": "Trac\\xE9 4105",
    d: "M215.79,101.451l7.4,9.019,3.879-8.775L220.6,93.566l-4.812,7.885Z",
    transform: "translate(307.017 119.692)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4106",
    "data-name": "Trac\\xE9 4106",
    d: "M216.8,95.847l2.055,92.831,13.127,19.29,8.219-19.29L221.921,96.055",
    transform: "translate(309.056 124.276)",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4107",
    "data-name": "Trac\\xE9 4107",
    d: "M442.827,133.1a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,442.827,133.1ZM181.364,216.266a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,181.364,216.266Z",
    transform: "translate(230.817 185.08)",
    fill: "#76bec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4108",
    "data-name": "Trac\\xE9 4108",
    d: "M236.466,112.217l14.581,66.658",
    transform: "translate(348.563 157.17)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4112",
    "data-name": "Trac\\xE9 4112",
    d: "M194.239,162.037s-4.147,6.476-9.522,8.3a68.679,68.679,0,0,1-11.412,2.447,3.169,3.169,0,0,0-2.341,3.343c0,1.863,1.174,3.362,2.63,3.362h6.828",
    transform: "translate(216.943 257.278)",
    fill: "none",
    stroke: "#010541",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4113",
    "data-name": "Trac\\xE9 4113",
    d: "M270.475,119.722c2.958-2.411,6.7-5.278,10.482-5.64a3.407,3.407,0,0,1,3.644,4.4c-.563,2.254-2.654,4.081-4.213,5.447-3.452,3.015-5.05,5.041-8.736,7.638",
    transform: "translate(416.901 160.872)",
    fill: "#f2d3dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4114",
    "data-name": "Trac\\xE9 4114",
    d: "M270.475,119.722c2.958-2.411,6.7-5.278,10.482-5.64a3.407,3.407,0,0,1,3.644,4.4c-.563,2.254-2.654,4.081-4.213,5.447-3.452,3.015-5.05,5.041-8.736,7.638",
    transform: "translate(416.901 160.872)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4115",
    "data-name": "Trac\\xE9 4115",
    d: "M308.282,291.207S294.033,117.673,279.81,94.745c0,0-50.326-23.233-68.849,41.644,0,0-32.234,105.245-37.467,158.213h45.914s17.31-56.538,20.238-80.273c0,0,4.036,67.609,9.5,76.872l-11.33-98.793",
    transform: "translate(222.027 113.93)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4116",
    "data-name": "Trac\\xE9 4116",
    d: "M217.252,92.126l-12.691,30.269L217.1,133.069l-10.407,17.072,34.1,85.726L217.252,92.126Z",
    transform: "translate(284.453 116.799)",
    fill: "#5a1819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4117",
    "data-name": "Trac\\xE9 4117",
    d: "M222.729,94.04a70.311,70.311,0,0,1,33.32,9.431c14.924,8.523,24.626,23.2,33.311,37.563,7.984,13.2,16.263,26.134,24.746,39l42.074-17,13.834,31s-36.955,41.34-47.428,44.35c0,0-36,15.315-51.223-23.01l21.433,58.3-42.129,3.5L222.729,94.04Z",
    transform: "translate(320.96 120.645)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4118",
    "data-name": "Trac\\xE9 4118",
    d: "M251.015,97.877l20.657,128.781,8.005-75.386-12.239-19.239,3.747-7.74ZM209.04,92.126s11.279,9.958,23.534,143.741C232.568,235.867,205.092,99.541,209.04,92.126Z",
    transform: "translate(292.674 116.799)",
    fill: "#5a1819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4119",
    "data-name": "Trac\\xE9 4119",
    d: "M195.127,126.762s3.753,72.837,10.142,88.7m142.468-8.827-26.2-72.981",
    transform: "translate(265.496 186.396)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4120",
    "data-name": "Trac\\xE9 4120",
    d: "M175.812,195.882H206.3m181.955-53.209s24.466,10.7,40.654-6.422",
    transform: "translate(226.685 205.463)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4121",
    "data-name": "Trac\\xE9 4121",
    d: "M226.8,162.4s11.087,43.949,9.335,80.817",
    transform: "translate(329.132 258.013)",
    fill: "none",
    stroke: "#010541",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4122",
    "data-name": "Trac\\xE9 4122",
    d: "M262.284,183.553s3.076,28.6-14.854,38.367",
    transform: "translate(370.594 300.512)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4123",
    "data-name": "Trac\\xE9 4123",
    d: "M337.727,391.617l-114.014,84.4m189.908-95.979s4.8,32.426-14.894,48.475M226.472,82.524s-21.376-.593-43.049,21.436",
    transform: "translate(241.978 97.501)",
    fill: "none",
    stroke: "#010541",
    strokeWidth: 0.246
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4124",
    "data-name": "Trac\\xE9 4124",
    d: "M344.554,161.46H290.959c-1.679,0-3.045-.737-3.045-1.559v-.421c0-.858,1.366-1.559,3.045-1.559h53.594c1.679,0,3.045.737,3.045,1.559v.421C347.6,160.759,346.233,161.46,344.554,161.46Z",
    transform: "translate(451.943 249.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4125",
    "data-name": "Trac\\xE9 4125",
    d: "M267.631,107.453H105.815a14.457,14.457,0,0,0-14.457,14.463v81.507a14.459,14.459,0,0,0,14.457,14.457H264.378a14.457,14.457,0,0,0,14.457-14.457v-84.8a11.18,11.18,0,0,0-11.168-11.174",
    transform: "translate(56.983 147.597)",
    fill: "#79a4e2",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4126",
    "data-name": "Trac\\xE9 4126",
    d: "M261.651,213.7H98.915a12.348,12.348,0,0,1-12.354-12.351V115.607a12.348,12.348,0,0,1,12.354-12.345H261.651a12.36,12.36,0,0,1,12.366,12.36v85.741a12.36,12.36,0,0,1-12.36,12.351",
    transform: "translate(47.344 139.175)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4127",
    "data-name": "Trac\\xE9 4127",
    d: "M126.609,137.278a5.065,5.065,0,1,1-5.063-5.066A5.065,5.065,0,0,1,126.609,137.278Z",
    transform: "translate(107.461 197.346)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4128",
    "data-name": "Trac\\xE9 4128",
    d: "M185.128,128.959H94.407c-1.035,0-1.887-.635-1.887-1.411v-.379c0-.773.852-1.411,1.887-1.411h90.721c1.035,0,1.884.638,1.884,1.411v.379C187.012,128.324,186.164,128.959,185.128,128.959Zm17.554-7.295H94.4c-1.032,0-1.884-.638-1.884-1.405v-.385c0-.776.852-1.4,1.887-1.4H202.682c1.035,0,1.887.626,1.887,1.4v.385C204.569,121,203.717,121.664,202.682,121.664Zm-.635,15.763H93.032c-.28,0-.512-.169-.512-.376v-.1c0-.208.232-.376.512-.376H202.047c.274,0,.5.169.5.376v.1c0,.208-.229.376-.5.376Zm0,5.817H93.032c-.28,0-.512-.169-.512-.376v-.1c0-.208.232-.376.512-.376H202.047c.274,0,.5.169.5.376v.1c0,.208-.229.376-.5.376Z",
    transform: "translate(59.318 169.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4129",
    "data-name": "Trac\\xE9 4129",
    d: "M195.728,167.019h-52.68a6.922,6.922,0,0,1-6.9-6.895V107.436a6.922,6.922,0,0,1,6.9-6.895h52.68a6.919,6.919,0,0,1,6.9,6.895v52.689A6.922,6.922,0,0,1,195.728,167.019Z",
    transform: "translate(146.978 133.708)",
    fill: "#ccddf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4130",
    "data-name": "Trac\\xE9 4130",
    d: "M192.931,164.4H140.246a6.922,6.922,0,0,1-6.9-6.9V104.818a6.922,6.922,0,0,1,6.9-6.9h52.686a6.916,6.916,0,0,1,6.894,6.9V157.5a6.922,6.922,0,0,1-6.895,6.9Z",
    transform: "translate(141.357 128.441)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4131",
    "data-name": "Trac\\xE9 4131",
    d: "M140.23,102.227l-2.555,2.549,37.87,37.976,2.555-2.546Z",
    transform: "translate(150.052 137.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4132",
    "data-name": "Trac\\xE9 4132",
    d: "M177.1,102.542,137.4,138.595l2.426,2.669,39.706-36.053Z",
    transform: "translate(149.492 137.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4133",
    "data-name": "Trac\\xE9 4133",
    d: "M112.373,137.3a5.082,5.082,0,1,1-1.484-3.581,5.056,5.056,0,0,1,1.484,3.581Zm21.418,0a5.056,5.056,0,1,1-1.48-3.583A5.053,5.053,0,0,1,133.791,137.3Z",
    transform: "translate(78.849 197.367)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4134",
    "data-name": "Trac\\xE9 4134",
    d: "M121.224,129.693H92.9a.373.373,0,0,1-.268-.114.385.385,0,0,1-.111-.271v-.093a.38.38,0,0,1,.111-.268.37.37,0,0,1,.268-.111h28.324a.38.38,0,0,1,.376.379v.093a.38.38,0,0,1-.111.271A.37.37,0,0,1,121.224,129.693Z",
    transform: "translate(59.318 190.562)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21912",
    "data-name": "Groupe 21912",
    transform: "translate(1110.668 578.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4172",
    "data-name": "Trac\\xE9 4172",
    d: "M56.554,241.97l58.869.842a4.124,4.124,0,0,0,3.8-2.962l12.633-48.289a2.291,2.291,0,0,0-2.228-3.05l-58.873-.856a4.108,4.108,0,0,0-3.8,2.96L54.327,238.9a2.289,2.289,0,0,0,2.228,3.046",
    transform: "translate(-15.662 -187.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4173",
    "data-name": "Trac\\xE9 4173",
    d: "M56.554,241.97l58.869.842a4.124,4.124,0,0,0,3.8-2.962l12.633-48.289a2.291,2.291,0,0,0-2.228-3.05l-58.873-.856a4.108,4.108,0,0,0-3.8,2.96L54.327,238.9a2.3,2.3,0,0,0,2.228,3.066Z",
    transform: "translate(-15.662 -187.655)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.257
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4174",
    "data-name": "Trac\\xE9 4174",
    d: "M59.428,241.97l58.871.842a4.126,4.126,0,0,0,3.8-2.962l12.633-48.289a2.291,2.291,0,0,0-2.228-3.05l-58.869-.856a4.113,4.113,0,0,0-3.8,2.96L57.2,238.9a2.289,2.289,0,0,0,2.228,3.046",
    transform: "translate(-23.772 -187.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4175",
    "data-name": "Trac\\xE9 4175",
    d: "M59.43,241.97l58.871.842a4.126,4.126,0,0,0,3.8-2.962l12.633-48.289a2.291,2.291,0,0,0-2.228-3.05l-58.869-.856a4.112,4.112,0,0,0-3.8,2.96L57.206,238.9a2.3,2.3,0,0,0,2.224,3.066Z",
    transform: "translate(-23.774 -187.655)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.257
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4176",
    "data-name": "Trac\\xE9 4176",
    d: "M61.982,234.4l51.374.707a3.564,3.564,0,0,0,3.317-2.428L127.711,193.1a1.9,1.9,0,0,0-1.942-2.5l-51.4-.7a3.546,3.546,0,0,0-3.273,2.433L60.06,231.91a1.9,1.9,0,0,0,1.942,2.5",
    transform: "translate(-21.954 -185.825)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4207",
    "data-name": "Trac\\xE9 4207",
    d: "M68.885,281.789H161.22c1.347,8.076-6.732,9.649-6.732,9.649H68.867a3.477,3.477,0,0,1-3.462-3.462v-2.733a3.47,3.47,0,0,1,3.462-3.462",
    transform: "translate(-65.405 -226.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4208",
    "data-name": "Trac\\xE9 4208",
    d: "M68.885,217.889H161.22c1.348,8.076-6.732,9.649-6.732,9.649H68.867a3.47,3.47,0,0,1-3.462-3.462v-2.733a3.464,3.464,0,0,1,3.481-3.453Z",
    transform: "translate(-65.405 -162.91)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.257
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4212",
    "data-name": "Trac\\xE9 4212",
    d: "M95.861,220.539H79.518m-6.13,0H69.422",
    transform: "translate(-7.2 -160.741)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.257
  })), /*#__PURE__*/React.createElement("text", {
    id: "OOPS",
    transform: "translate(728 1053)",
    fill: "#a02528",
    fontSize: 128,
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -162,
    y: 0
  }, "OOPS")), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(844.277 480)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    d: "M5.861,6.568-.354.354.354-.354,6.568,5.861Z",
    transform: "translate(324.893 114.564)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_10",
    "data-name": "Ligne 10",
    d: "M.354,6.568l-.707-.707L5.861-.354l.707.707Z",
    transform: "translate(324.893 114.564)",
    fill: "#ffafaf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(844.277 480)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_11",
    "data-name": "Ligne 11",
    d: "M5.861,6.568-.354.354.354-.354,6.568,5.861Z",
    transform: "translate(343.234 114.564)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_12",
    "data-name": "Ligne 12",
    d: "M.354,6.568l-.707-.707L5.861-.354l.707.707Z",
    transform: "translate(343.234 114.564)",
    fill: "#ffafaf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_13",
    "data-name": "Ligne 13",
    d: "M18.341.5H0v-1H18.341Z",
    transform: "translate(1175.385 606.629)",
    fill: "#ffafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M339.778,126.129h7.063v6.384a3.531,3.531,0,1,1-7.063,0Zm6.063,1h-5.063v5.384a2.531,2.531,0,1,0,5.063,0Z",
    transform: "translate(844.277 480)",
    fill: "#ffafaf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOops);
export default __webpack_public_path__ + "static/media/oops.93d9efd819029741e2fe962afd223031.svg";
export { ForwardRef as ReactComponent };